import api from '@/http'

const state = () => ({})

const getters = {}

const actions = {
  getUpcomingGames(ctx, data) {
    return new Promise((resolve, reject) => {
      api
        .get(`manager/team/upcoming-games`, {
          params: { page: data.page, 'per-page': data.perPage },
        })
        .then(({ data, response }) => {
          resolve({ data, response })
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getFinishedGames(ctx, data) {
    return new Promise((resolve, reject) => {
      api
        .get(`manager/team/finished-games`, {
          params: { page: data.page, 'per-page': data.perPage },
        })
        .then(({ data, response }) => {
          resolve({ data, response })
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
